// COMFYLUXE: live-update the free-shipping progress bar from /cart.js
(function () {
  var THRESHOLD = 7500; // $75.00 in cents

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function updateBar() {
    var bar = document.querySelector('[data-fs-bar]');
    if (!bar) return;
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var total = cart.total_price || 0;
        var remaining = THRESHOLD - total;
        var pct = Math.min(100, Math.round((total / THRESHOLD) * 100));
        var textEl = bar.querySelector('[data-fs-text]');
        var fillEl = bar.querySelector('[data-fs-fill]');
        if (fillEl) fillEl.style.width = pct + '%';
        if (textEl) {
          if (remaining > 0) {
            textEl.innerHTML = "You're <strong>" + formatMoney(remaining) + "</strong> away from <strong>FREE shipping</strong>";
          } else {
            textEl.innerHTML = "You've unlocked <strong>FREE shipping</strong>";
          }
        }
      })
      .catch(function () { /* keep Liquid-rendered fallback */ });
  }

  // Initial update
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateBar);
  } else {
    updateBar();
  }

  // Re-check when the cart drawer/popover changes (quantity steppers, removals)
  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var t = mutations[i].target;
      if (t && t.closest && t.closest('[data-filter-drawer], .quick-cart, [data-cart-drawer], body')) {
        updateBar();
        break;
      }
    }
  });

  // Watch for subtree changes in the cart area
  document.addEventListener('DOMContentLoaded', function () {
    var cartRoot = document.querySelector('.quick-cart') || document.body;
    observer.observe(cartRoot, { childList: true, subtree: true, characterData: true });
  });

  // Also update on common cart events themes dispatch
  ['cart:updated', 'cart:change', 'ajaxCart.afterCartLoad'].forEach(function (evt) {
    document.addEventListener(evt, updateBar);
  });

  // Fallback: refresh shortly after any click inside the cart drawer
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.quick-cart')) {
      setTimeout(updateBar, 600);
      setTimeout(updateBar, 1500);
    }
  });
})();
